import React, { useEffect, useState } from 'react'
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { 
  Box,
	Button,
	Container, 
	LinearProgress, 
	Typography 
} from '@mui/material';

import PublicRoutes from './publicRoutes';
import ProtectedRoutes from './protectedRoutes';
import ErrorHandler from '../components/errorHandler/ErrorHandler';
import Navigation from "../components/navigation/Navigation";
import packageJson from "../../package.json"; 

import { ReactComponent as Logo }  from "../assets/icons/lusidpay_logo.svg";

import { 
  CLEAR_COMPANY_ROLE_DASHBOARD, 
  LOG_OUT 
} from '../redux/actionTypes';

//routes
import AuthPage from '../views/authPage/AuthPage';
import RegisterPage from '../views/authPage/RegisterPage';
import ForgotPasswordPage from '../views/authPage/ForgotPasswordPage';
import CreatePasswordPage from '../views/authPage/CreatePasswordPage';
import HomePage from '../views/homePage/HomePage';

import CompaniesPage from '../views/dashboard/companiesPage/CompaniesPage';
import ProfilePage from '../views/dashboard/profilePage/ProfilePage';
import DataIngestion from '../views/homePage/DataIngestion';
import PreAuditVerification from '../views/homePage/PreAuditVerification';
import BrokerResolutionDesk from '../views/homePage/BrokerResolutionDesk';
import Archive from '../views/homePage/Archive';


const MainRouter = () => {

  return (
    <Router>
      <Routes>
        <Route element={<PublicRoutes />}>
          <Route path='/auth' element={<AuthPage />} />
          <Route path='/register' element={<RegisterPage />} />
          <Route path='/forgot-password' element={<ForgotPasswordPage />} />
          <Route path='/create-password' element={<CreatePasswordPage />} />
        </Route>
        <Route element={<ProtectedRoutes />}>
          <Route path="/switch" element={<CompanySwitchScreen />} />

          <Route path='/' element={<Navigation />}>
            <Route path='' element={<HomePage />} />

            {/* DASI Trade Defense pages */}
            <Route path='data-ingestion' element={<DataIngestion />} />
            <Route path='pre-audit-verification' element={<PreAuditVerification />} />
            <Route path='broker-resolution-desk' element={<BrokerResolutionDesk />} />
            <Route path='archive' element={<Archive />} />

            {/* dashboard */}
            <Route path='dashboard' element={<CompaniesPage />} />
            <Route path='profile' element={<ProfilePage />} />

          </Route>

        </Route>
        <Route path="/version" element={<AppVersion />} />
        <Route path='*' element={<NotFoundPage />} />
      </Routes>
      <ErrorHandler />
    </Router>
  )
}

export default MainRouter;

// 404 page
const NotFoundPage = () => {
  const navigate = useNavigate();
  return(
		<Container maxWidth="lg">
      <Box sx={{ height: "100vh" }} 
        gap={"40px"}
        className="flexCenterCenterColumn">
			  <Typography variant='h4'>404 - Page not found</Typography>
        <Button 
          variant='contained'
          onClick={() => navigate("/dashboard")}>
          Go Home
        </Button>
      </Box>
		</Container>
  )
};

// Company switch screen
const CompanySwitchScreen = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    console.log(location)

    try {
      // setTimeout(() => {
        dispatch({ type: CLEAR_COMPANY_ROLE_DASHBOARD });
        // dispatch(GetCompanyInfo(companyId, setLoading)).then(({ res, statusCode }) => {
        //   setLoading(true);
        // })
        setTimeout(() => {
          setLoading(false);
          navigate(location.state, { replace: true });
        }, 1000);
      // }, 200);
    } catch (err){
      dispatch({ type: LOG_OUT });
    }
    
    // const navTimer = setTimeout(() => {
    //   navigate(location.state, { replace: true });
    // }, 500);
    // const valueTimer = setInterval(() => {
    //   setProgress((prevProgress) => (prevProgress >= 100 ? 100 : prevProgress + 3));
    // }, 10); // 20 milliseconds interval will take 2000 ms to reach 100

    return () => {
      // clearInterval(navTimer);
      // clearInterval(valueTimer);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <Box
      className="flexCenterCenterColumn"
      gap="40px"
      width={"100%"}
      height={"100vh"}>

      <Box
        maxWidth={'350px'}
        height={"100px"}
        className="animate__faster animate__animated animate__zoomIn ">
        <Logo 
          style={{ width: "420px", height: "100px" }}/>
      </Box>

      <LinearProgress 
        sx={{ width: "320px" }}
        // variant="determinate"
        // value={progress}
        value={loading}
        />

      <Typography
        color="grey"
        variant='subtitle1'>
        Switching company
      </Typography>

    </Box>
  )
};

const AppVersion = () => {
  return(
    <Box
      sx={{ height: "100vh" }}>
      <Typography
        color={"black"}>
        App version: {packageJson.version}
      </Typography>
    </Box>
  )
};